"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _linkList = babelHelpers.interopRequireDefault(require("./linkList"));

var _prositeBrandLink = babelHelpers.interopRequireDefault(require("card/block/prositeBrandLink"));

var _decorators = require("decorators");

var PrositeBrandList =
/*#__PURE__*/
function (_LinkList) {
  babelHelpers.inherits(PrositeBrandList, _LinkList);

  function PrositeBrandList() {
    babelHelpers.classCallCheck(this, PrositeBrandList);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PrositeBrandList).apply(this, arguments));
  }

  return PrositeBrandList;
}(_linkList.default);

exports.default = PrositeBrandList;